/* eslint-disable no-param-reassign */

export function makeGoogleTracking () {
    return {
        namespaced: true,
        actions: {
            /**
             * Initializes analytics on the current page.
             * gtag.js automaically sends a pageview.
             */
            init ({ rootState }) {
                // Measurement ID
                const { GOOGLE_ANALYTICS_ID } = rootState.solution.config;

                if (GOOGLE_ANALYTICS_ID) {
                    // Global site tag (gtag)
                    const script = document.createElement('script');
                    script.async = true;
                    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
                    document.head.append(script);

                    window.dataLayer = window.dataLayer || [];
                    // eslint-disable-next-line
                    function gtag () { dataLayer.push(arguments); }
                    gtag('js', new Date());
                    gtag('set', {
                        campaign: {
                            source: rootState.tracking.utm.source,
                        },
                    });
                    gtag('config', GOOGLE_ANALYTICS_ID);

                    console.log(`[Tracking:Google] ✅ Initialized (${GOOGLE_ANALYTICS_ID})`);
                } else {
                    console.log('[Tracking:Google] ❌ Not configured: skipped');
                }
            },
        },
    };
}
